export default __webpack_public_path__ + "static/media/Fence's Armbands of the Dusk Rebellion.756e4b94.jpg";